export default [
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      requireAuth: true,
      requireFields: true,
      // The hub's page here.
      help: 'view-orders',
    },
    component: () => import('@/views/Orders/index.vue'),
  },
]
